class DesktopNavigation extends HTMLElement {
  connectedCallback() {
    this.nav = this.querySelector('nav');
    this.entries = Array.from(this.nav.querySelectorAll(':scope > ul > .list-menu__items'), (item) => ({
      item,
      trigger: item.querySelector(':scope > .header__menu-item'),
      panel: item.querySelector(':scope > .mega-menu__content, :scope > .header__submenu-dropdown'),
      dropdown: item.classList.contains('list-menu__has-dropdown'),
    }));
    this.activeEntry = null;
    this.events = new AbortController();
    const options = { signal: this.events.signal };

    this.entries.forEach((entry) => this.setOpen(entry, false));
    this.addEventListener('pointerover', (event) => this.onPointer(event), options);
    this.addEventListener('pointerout', (event) => this.onPointer(event), options);
    this.addEventListener('click', (event) => {
      const entry = this.entryFor(event.target);
      if (entry?.trigger.contains(event.target)) this.activate(entry);
    }, options);

    this.addEventListener('focusin', (event) => {
      this.activate(this.entryFor(event.target));
    }, options);
    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget)) this.activate(null);
    }, options);
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !this.activeEntry) return;
      event.preventDefault();
      this.activeEntry.trigger.focus();
      this.activate(null);
    }, options);
    document.addEventListener('pointerdown', (event) => {
      if (!this.contains(event.target)) this.activate(null);
    }, options);
    window.addEventListener('resize', () => this.activate(null), options);
    this.nav.classList.add('header__inline-menu--managed');
  }

  entryFor(target) {
    return this.entries.find(({ item }) => item.contains(target));
  }

  onPointer(event) {
    if (event.pointerType === 'touch') return;
    const entry = this.entryFor(event.target);
    const region = entry?.panel?.contains(event.target) ? entry.panel : entry?.trigger;
    // Ignore moves within a trigger or panel, but handle moves between the two.
    if (!region?.contains(event.target) || region.contains(event.relatedTarget)) return;
    if (event.type === 'pointerout') this.schedule(null);
    else if (region === entry.panel || !this.activeEntry || this.activeEntry === entry) this.activate(entry);
    else this.schedule(entry);
  }

  schedule(entry) {
    window.clearTimeout(this.timer);
    // Let the pointer cross a wrapped row before closing or switching panels.
    this.timer = window.setTimeout(() => this.activate(entry), 150);
  }

  activate(entry) {
    window.clearTimeout(this.timer);
    if (!entry?.panel || !window.matchMedia('(min-width: 1150px)').matches) entry = null;
    if (entry === this.activeEntry) return;

    this.setOpen(this.activeEntry, false);
    if (entry?.dropdown) {
      entry.item.style.setProperty('--header-dropdown-offset', `${this.nav.getBoundingClientRect().bottom - entry.item.getBoundingClientRect().bottom}px`);
    }
    this.setOpen(entry, true);
    this.activeEntry = entry;
  }

  setOpen(entry, open) {
    if (!entry?.panel) return;
    entry.item.classList.toggle('is-open', open);
    entry.trigger.setAttribute('aria-expanded', String(open));
    entry.panel.inert = !open;
  }

  disconnectedCallback() {
    this.activate(null);
    this.events.abort();
    this.nav.classList.remove('header__inline-menu--managed');
    this.entries.forEach(({ trigger, panel }) => {
      trigger.removeAttribute('aria-expanded');
      if (panel) panel.inert = false;
    });
  }
}

if (!customElements.get('desktop-navigation')) {
  customElements.define('desktop-navigation', DesktopNavigation);
}
